import { useLanguage } from '@/contexts/LanguageContext';
import { en, fr, ar } from '@/i18n/translations';

const translations = { en, fr, ar };

function formatDate(date: string, language: 'en' | 'fr' | 'ar'): string {
  const dateObj = new Date(date);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  
  return new Intl.DateTimeFormat(
    language === 'ar' ? 'ar-SA' : 
    language === 'fr' ? 'fr-FR' : 
    'en-US', 
    options
  ).format(dateObj);
}

function useTranslation() {
  const { language, isRTL } = useLanguage();
  
  function translate(key: string, params: { date?: string } = {}): string {
    const keys = key.split('.');
    let value: any = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    if (typeof value !== 'string') {
      console.warn(`Translation key "${key}" not found for language "${language}"`);
      return key;
    }
    
    // Handle date parameter with proper localization
    if (params.date) {
      return value.replace('{{date}}', formatDate(params.date, language));
    }
    
    return value;
  }
  
  return { translate };
}

export default useTranslation;
